export const creditsText = `
    <strong>Tarnished House</strong> is a vision wrought by
    <strong>Tahsin Önemli</strong>, inspired by thee and thy
    <strong>Three.js Journey Haunted House</strong> lesson.<br /><br />

    Though the first ember was borrowed, all that lies within this
    forsaken graveyard – the withered earth, the shattered tombstones,
    and the smoldering bonfire – was shaped anew by hand and will
    alone.<br /><br />

    Forged in but many days and sleepless nights, this cursed land
    stands as testament to fevered resolve. The ruined dwelling, now
    called <strong>Tarnished House</strong>, remains as a solitary
    beacon in the land of the dead, its only warmth the fire that
    yet endureth.<br /><br />

    <em>
      Below lie the relics gathered and forged in the making of this
      forsaken land.
    </em>
    <br /><br />

    <em>
      “May thy flame kindle light amidst the endless night,<br />O
      Tarnished one.”
    </em>
    <br />
`;
